module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/localidade/localidade.component.css
// module id = ./src/app/localidade/localidade.component.css
// module chunks = main